import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { TriviaQuestionAnswerDto } from '../../../models/dtos/triviaQuestionAnswer.dto';
import { TriviaQuestionAnswerRequest } from '../../../models/requests/triviaQuestionAnswer.request';
import { Errors } from '../../errors';
import sendTriviaQuestionAnswerRequest from './sendTriviaQuestionAnswer.repository';

type InitialState = {
  loading: boolean;
  data?: TriviaQuestionAnswerDto;
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const sendTriviaQuestionAnswer = createAsyncThunk(
  'sendTriviaQuestionAnswer',
  async (request: TriviaQuestionAnswerRequest, { rejectWithValue }) => {
    try {
      return await sendTriviaQuestionAnswerRequest(request);
    } catch (error) {
      return rejectWithValue(Errors.getErrorDtoFromApiError(error));
    }
  }
);

const sendTriviaQuestionAnswerSlice = createSlice({
  name: 'sendTriviaQuestionAnswer',
  initialState,
  reducers: {
    sendTriviaQuestionAnswerReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sendTriviaQuestionAnswer.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      sendTriviaQuestionAnswer.fulfilled,
      (state, action: PayloadAction<TriviaQuestionAnswerDto>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(sendTriviaQuestionAnswer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as any;
    });
  },
});

export default sendTriviaQuestionAnswerSlice.reducer;
export const { sendTriviaQuestionAnswerReset } = sendTriviaQuestionAnswerSlice.actions;
